"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

/**
 * Marks the document with the route family, for the few chrome rules that
 * depend on which page is open.
 *
 * Today that is one rule: the full-screen atlas on a phone, where the floating
 * WhatsApp and concierge buttons sit on top of the map itself and cover pins
 * in the bottom corners. The buttons are in the layout, far from the page that
 * needs them out of the way, so the page says what it is and CSS does the
 * rest.
 */
export function RouteFlags() {
  const pathname = usePathname() || "/";

  useEffect(() => {
    const root = document.documentElement;
    const family = pathname === "/maps" || pathname.startsWith("/maps/") ? "maps" : "";
    if (family) root.setAttribute("data-route", family);
    else root.removeAttribute("data-route");
    return () => root.removeAttribute("data-route");
  }, [pathname]);

  return null;
}
